/**
 * The single binding table. The shortcut sheet is generated from it, so the sheet and the
 * handlers cannot drift.
 *
 * Single key shortcuts fire only when focus is in a list or a drawer, never in an input.
 */
export interface Binding {
  keys: string;
  action: string;
  scope: 'Global' | 'Lists' | 'Order drawer' | 'Stock';
}

export const BINDINGS: readonly Binding[] = [
  { keys: 'Ctrl K or Cmd K', action: 'Command palette', scope: 'Global' },
  { keys: 'g then h', action: 'Home', scope: 'Global' },
  { keys: 'g then o', action: 'Orders', scope: 'Global' },
  { keys: 'g then s', action: 'Stock', scope: 'Global' },
  { keys: 'g then c', action: 'Customers', scope: 'Global' },
  { keys: 'g then u', action: 'Support', scope: 'Global' },
  { keys: 'g then f', action: 'Finance', scope: 'Global' },
  { keys: 'g then w', action: 'Growth', scope: 'Global' },
  { keys: 'g then ,', action: 'Settings', scope: 'Global' },
  { keys: 'i', action: 'Action Inbox', scope: 'Global' },
  { keys: '?', action: 'This sheet', scope: 'Global' },
  { keys: 'Esc', action: 'Close a drawer or clear a selection', scope: 'Global' },
  { keys: 'j and k', action: 'Move down and up', scope: 'Lists' },
  { keys: 'Enter', action: 'Open the focused row', scope: 'Lists' },
  { keys: 'x', action: 'Toggle selection', scope: 'Lists' },
  { keys: 'Shift x', action: 'Select a range', scope: 'Lists' },
  { keys: 'Ctrl a or Cmd a', action: 'Select everything visible', scope: 'Lists' },
  { keys: '/', action: 'Focus the list search', scope: 'Lists' },
  { keys: '1 to 8', action: 'Switch queue in rail order', scope: 'Lists' },
  { keys: 'p', action: 'Print all for this order', scope: 'Order drawer' },
  { keys: 'Shift p', action: 'Print menu', scope: 'Order drawer' },
  { keys: 'm', action: 'Mark paid', scope: 'Order drawer' },
  { keys: 'Shift m', action: 'Mark packed', scope: 'Order drawer' },
  { keys: 'e', action: 'Edit mode', scope: 'Order drawer' },
  { keys: 'Ctrl s or Cmd s', action: 'Save', scope: 'Order drawer' },
  { keys: 'n', action: 'Add a note', scope: 'Order drawer' },
  { keys: 't', action: 'Update tracking', scope: 'Order drawer' },
  { keys: 'e', action: 'Edit the price on the focused row', scope: 'Stock' },
  { keys: 'a', action: 'Adjust stock', scope: 'Stock' },
  { keys: 'Enter on WAC', action: 'Open the cost breakdown', scope: 'Stock' },
];

/** g then <key> destinations, matching the table above. */
export const GO_TO: Readonly<Record<string, string>> = {
  h: '/',
  o: '/orders',
  s: '/stock',
  c: '/customers',
  u: '/support',
  f: '/finance',
  w: '/growth',
  ',': '/settings',
};
